export const BoxContract = {

    async index() {
        
        throw new Error("boxes index not implemented");
    },

    async box_consumables_index() {
        
        throw new Error("boxes box_consumables_index not implemented");
    }
}